import {
    FilesUpdateRequest,
    IPictureFileMetadataResponse,
    PictureFileMetadataResponse,
} from '@kcftech/prometheustypescriptapiclient';
import { QueryObserverResult } from '@tanstack/react-query';
import { TextInlineEditor } from 'components/inline_edit/TextInlineEditor';
import { sdClient } from 'contexts/SDKClientContext';

const maxDescriptionLength = 200;

const validate = (val: string | undefined) => {
    if (val && val.length > maxDescriptionLength) {
        return `Description must be ${maxDescriptionLength} characters or less`;
    }
    return undefined;
};

export type FileDetailsDescriptionProps = Readonly<{
    file: IPictureFileMetadataResponse;
    canEdit: boolean;
    refetchFile: () => Promise<
        QueryObserverResult<PictureFileMetadataResponse | undefined, unknown>
    >;
    refreshTable: () => void;
}>;

export function FileDetailsDescriptionEditor({
    file,
    canEdit,
    refetchFile,
    refreshTable,
}: FileDetailsDescriptionProps) {
    const onConfirm = async (updatedDescription: string | undefined) => {
        try {
            await sdClient
                .updateFile({
                    fileId: file.Id,
                    body: new FilesUpdateRequest({
                        DisplayName: file.DisplayName,
                        ParentFolderId: file.ParentFolderId ?? '',
                        Description: updatedDescription,
                        GroupIds: file.GroupIds,
                    }),
                })
                .then(refetchFile)
                .then(refreshTable);
        } catch {
            return 'Unable to save description for File';
        }
        return undefined;
    };

    return (
        <TextInlineEditor
            valueClass="word-break"
            editorStyle={{ width: '50rem', marginTop: '-8px' }}
            isDisabled={!canEdit}
            value={file.Description}
            validate={validate}
            onConfirm={onConfirm}
        />
    );
}
